import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { LoadingOutlined } from '@ant-design/icons';
import { setLoading } from '../../redux/actions/miscActions';
import Preloader from '../../components/common/Preloader';
import * as ROUTE from '../../constants/routes';
import {Link} from 'react-router-dom';
import {apiUrl} from '../../helpers/utils'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15rem',
    marginBottom: '30px'
  },
  nextButton: {
    margin: 'auto',
    marginBottom: '8px'
  },
  start: {
    display: 'grid',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    /* bring your own prefixes */
    transform: 'translate(-50%, -50%)'
  },
  shop: {
    display: 'contents',
    marginTop: '100px',
    justifyContent: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    /* bring your own prefixes */
    transform: 'translate(-50%, -50%)'
  },
  title: {
    fontFamily: 'raleway',
    color: '#36b0c9',
    display: 'grid',
    justifyContent: 'center',
    marginTop: '100px'
  },
  subtitle: {
    fontFamily: 'raleway',
    display: 'grid',
    textAlign: 'center',
    fontWeight: '400'
  }
}));


const Striped = () => {
  const [account, setAccount] = useState({ });
  const [stripeLink, setStripeLink] = useState('');
  
  const { auth, loading } = useSelector((state) => ({
    auth: state.auth,
    loading: state.app.loading
  }));

  const dispatch = useDispatch();

  useEffect(() => {
    verifyAccount();
  }, []);

  const classes = useStyles();
  
  const httpRequestGetStripeLink = async () => {
    await fetch(`${apiUrl}/stripe?id=${auth.id}/`)
    .then((response) => {
      const json = response.json();
      if (response.ok) {
        return json;
      }
      return Promise.reject('Something went wrong.');
    })
    .then((json) => {
      setStripeLink(json.accountLink.url)
    })
    .catch((e) => {
      console.log('e', e);
    });
  };


  const verifyAccount = async () => {
    dispatch(setLoading(true));
    const response = await fetch(`${apiUrl}/striped?id=${auth.id}/`);
    if (response.ok) {
      const fetchedAccount = await response.json();
      setAccount(fetchedAccount.account);
      if(!fetchedAccount.account.charges_enabled) await httpRequestGetStripeLink()
      dispatch(setLoading(false));
    } else {
      console.log('Error fetching account');
      dispatch(setLoading(false));
    }
  };

  return (
    loading ? (
      <div className={classes.start}>
        <Preloader />
      </div>
    )
      : account.charges_enabled
        ? (
          <div className={classes.start}>
            <h1 className={classes.title}> Payout account connected!</h1>
            <p className={classes.subtitle}>
              Ok! You're connected to Stripe and ready to receive payments. <br/> Let's invite your friends!
            </p>
            <Link
                className="invite-button"
                to={ROUTE.INVITE}
            >
              Invite your friends
            </Link>
          </div>
        )
        : (
            <div className={classes.start}>
              <h1 className={classes.title}>Stripe account not yet ready to receive payments.</h1>
              <p className={classes.subtitle}>
                Looks like stripe requires some more information from you.
                <br />
                before you can receive payments from friends.
              </p>
              <a href={stripeLink} className={classes.nextButton}>
                <button
                    type="button"
                    className="onboard-button"
                    color="primary"
                    onClick={async () => {
                    }}
                >
                  Finish setting up stripe
                </button>
              </a>
              <Link
                  className="invite-button"
                  to={ROUTE.INVITE}
              >
                Skip for now
              </Link>
            </div>
        )

  );
};

export default Striped;
